import { lazy } from "react";
/**
 Maps the Monarch UI Component customId to the React component path in our repo
 * */
const listOfMonarchComponents = {
  /* HEROES */
  frdcHeroRedesignEditable: lazy(
    () => import("@monarch/Hero | Redesign - Editable"),
  ),
  infrHeroCarouselRedesignEditable: lazy(
    () => import("@monarch/Hero | Carousel | Redesign - Editable"),
  ),
  frdcHeroPricePointTieredEditable: lazy(
    () => import("@monarch/Hero | Price Point | Tiered - Editable"),
  ),
  infrHeroEditable: lazy(() => import("@monarch/Hero - Editable")),
  frdcShopHeroPricePointTiered5G: lazy(
    () => import("@monarch/Shop - Hero | Price Point - Tiered 5G"),
  ),
  frdcInfrHeroGetVrcBackEditable: lazy(
    () => import("@monarch/Hero | Get VRC Back - Editable"),
  ),

  /* BANNERS */
  frdcNavBannerMobileEditable: lazy(
    () => import("@monarch/Nav | Banner | Mobile - Editable"),
  ),
  frdcBannerDaysCountdownEditable: lazy(
    () => import("@monarch/Banner | Days Countdown - Editable"),
  ),
  frdcBannerServiceCheckSingleLine: lazy(
    () => import("@monarch/Banner | Service Check Single Line"),
  ),
  frdcBannerCountdownEditable: lazy(
    () => import("@monarch/Banner - Countdown - Editable"),
  ),
  frdcBannerHeadingEditable: lazy(
    () => import("@monarch/Banner | Heading - Editable"),
  ),
  frdcNavBannerDesktopEditable: lazy(
    () => import("@monarch/Nav | Banner | Desktop - Editable"),
  ),
  frdcInfrBannerModernEditable: lazy(
    () => import("@monarch/Banner | Modern - Editable"),
  ),
  frdcInfrBannerVerizonEditable: lazy(
    () => import("@monarch/Banner | Verizon - Editable"),
  ),

  /* MODALS */
  infrModalGdt: lazy(() => import("@monarch/Home | Modal | GDT")),
  infrModalReturnVisitorRefreshImage: lazy(
    () => import("@monarch/Modal | Return Visitor Refresh Image"),
  ),
  infrModalReturnVisitorRefreshDualCta: lazy(
    () => import("@monarch/Modal | Return Visitor Refresh Dual CTA - Editable"),
  ),
  frdcInfrModalResumeQuote: lazy(
    () => import("@monarch/Modal | Resume Quote - Editable"),
  ),
  frdcInfrModalTabs: lazy(() => import("@monarch/Modal | Tabs")),

  /* SECTIONS */
  frdcSectionOffersEditable: lazy(
    () => import("@monarch/Section | Offers - Editable"),
  ),
  infrSectionEmailCaptureEditable: lazy(
    () => import("@monarch/Section | Email Capture - Editable"),
  ),
  infrSectionEmpty: lazy(() => import("@monarch/Section | Empty")),
  frdcSectionGdtEditable: lazy(
    () => import("@monarch/Section | GDT - Editable"),
  ),
  frdcSectionBentoFiberEducationEditable: lazy(
    () => import("@monarch/Section | Bento | Fiber Education - Editable"),
  ),
  frdcSectionTestimonialsEditable: lazy(
    () => import("@monarch/Section | Testimonials - Editable"),
  ),
  infrSectionProductCardsBricksEditable: lazy(
    () => import("@monarch/Section | Product Cards (Bricks) - Editable"),
  ),
  frdcInfrSectionAllPlanIncludeEditable: lazy(
    () => import("@monarch/Section | All Plan Include - Editable"),
  ),
  frdcSectionPlanFeatures: lazy(
    () => import("@monarch/Section | Plan Features"),
  ),
  frdcSectionFaQsFrdcRedesign: lazy(
    () => import("@monarch/Section | FAQs - Editable"),
  ),
  infrSectionGdtQuiz: lazy(() => import("@monarch/Section | GDT | QUIZ")),
  infrSectionStickyCta: lazy(() => import("@monarch/Section | Sticky CTA")),
  frdcSectionWhyFrontierEditable: lazy(
    () => import("@monarch/Section | Why Frontier - Editable"),
  ),
  frdcSectionVasEditable: lazy(
    () => import("@monarch/Section | VAS - Editable"),
  ),
  infrSectionStickyCtaGdt: lazy(
    () => import("@monarch/Section | Sticky CTA | GDT"),
  ),
  infrSectionGdtCta: lazy(() => import("@monarch/Section | GDT | CTA")),
  frdcSectionComparisonGrid: lazy(
    () => import("@monarch/Section | Comparison Grid"),
  ),
  frdcSectionProductCardsExpansionEditable: lazy(
    () => import("@monarch/Section | Product Cards | Expansion - Editable"),
  ),
  frdcInfrSectionGdtEditable: lazy(
    () => import("@monarch/Section | GDT - Editable"),
  ),
  frdcInfrSectionSimpleCheckoutEditable: lazy(
    () => import("@monarch/Section | Simple Checkout - Editable"),
  ),
  frdcSectionRecommendationBannerEditable: lazy(
    () => import("@monarch/Section | Recommendation Banner - Editable"),
  ),
  infrSectionBundlesEditable: lazy(
    () => import("@monarch/Section | Bundles - Editable"),
  ),
  frdcSectionSplitSectionCallCenterEditable: lazy(
    () => import("@monarch/Section | Split Section | Call Center - Editable"),
  ),
  frdcInfrSectionProductCards2X2Editable: lazy(
    () => import("@monarch/Section | Product Cards | 2x2 - Editable"),
  ),
  frdcInfrSectionProductCardsDesktopSimplifiedEditable: lazy(
    () =>
      import("@monarch/Section | Product Cards | Desktop Simplified - Editable"),
  ),
};

export default listOfMonarchComponents;
